"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.delete.confirm.title': 'Eliminar Profesión',
    'profession.delete.confirm.message': '¿Está seguro de que desea eliminar esta profesión?',
};
